import React from 'react';
import { useIntl } from 'react-intl';
import CustomInput from '../../../generic/CustomInput';

const InputsAboutPerson = ({ register, fieldAgensInfo, disabledInput, resCreateFieldAgent }) => {
  const translate = useIntl();
  return (
    <div className="assign__inputs-wrapper">
      <CustomInput
        name="name"
        type="text"
        label={translate.formatMessage({ id: 'about.first' })}
        placeholder={translate.formatMessage({ id: 'about.first' })}
        customClassLabel="input__label-fa-popup bold"
        customClass="input__fa-popup"
        value={fieldAgensInfo?.field_agent_name}
        disabled={disabledInput}
        register={register({
          required: false,
        })}
      />
      <div>
        <CustomInput
          name="email"
          type="text"
          label={translate.formatMessage({ id: 'acc.input-email' })}
          placeholder={translate.formatMessage({ id: 'acc.input-email' })}
          customClassLabel="input__label-fa-popup bold"
          customClass="input__fa-popup"
          value={fieldAgensInfo?.field_agent_email}
          error={resCreateFieldAgent}
          disabled={disabledInput}
          register={register({
            required: false,
            maxLength: 180,
            // eslint-disable-next-line no-useless-escape
            pattern: /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
          })}
        />
        {resCreateFieldAgent ? <div className="input__fa-error">{resCreateFieldAgent}</div> : null}
      </div>
    </div>
  );
};
export default InputsAboutPerson;
